import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import withFeatureFlags from 'hocs/withFeatureFlags';
import styles from './style.css';

class Welcome extends React.Component {
  render() {
    const { kybNewContent } = this.props;
    return (
      <div className={`row ${styles['row-center']}`}>
        <div className="col-md-12">
          <img src="https://s3-ap-southeast-1.amazonaws.com/backoffice.mokapos.com/images/dsc-09838%402x.jpg" />
          <h2>Welcome to Moka!</h2>
          {!kybNewContent && (
            <p>
              Before you get started on your store, we just need a few last
              details so you can start using mobile payments.
            </p>
          )}
          {kybNewContent && (
            <p>
              Before you get started on your store, we just need a few last
              details so you can start using our products.
            </p>
          )}
          {!kybNewContent && (
            <p
              className={`btn btn-primary btn-block ${styles.activate}`}
              onClick={this.props.onClickActivateMobilePayments}
            >
              Activate Mobile Payments Now
            </p>
          )}
          {kybNewContent && (
            <p
              className={`btn btn-primary btn-block ${styles.activate}`}
              onClick={this.props.onClickActivateMobilePayments}
            >
              Complete Your Identity
            </p>
          )}
          {!kybNewContent && (
            <Link to="/dashboard" className={`${styles.link}`}>
              I'll do this later
            </Link>
          )}
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    data: state,
  };
}

function mapFeatureFlags(flags) {
  return {
    kybNewContent: flags.kybNewContent,
  };
}

export default withFeatureFlags(mapFeatureFlags)(connect(select)(Welcome));
